import { Reveal } from "@/components/Reveal";

const COVER =
  "https://images.unsplash.com/photo-1572021335469-31706a17aaef?fm=jpg&q=85&w=2400&auto=format&fit=crop";

export default function CoverStory() {
  return (
    <section data-testid="hero-section" className="pb-20">
      <Reveal delay={0.1} className="max-w-[1400px] mx-auto px-6">
        <div className="overflow-hidden">
          <img
            src={COVER}
            alt="A small team smiling together around a laptop"
            className="w-full aspect-[16/9] object-cover"
          />
        </div>
        <p className="mt-3 text-[11px] tracking-[0.2em] uppercase text-[#6F6F63] text-right">
          Good work starts around a small table. Photographed in warm light.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="max-w-[1200px] mx-auto px-6 mt-12">
        <div data-testid="hero-stats" className="grid grid-cols-3 gap-6 border-t border-[#E5E5DE] pt-8">
          {[
            ["HQ", "Mississauga, ON"],
            ["Focus", "Tech & Internet"],
            ["Reach", "Buyers × Suppliers"],
          ].map(([k, v]) => (
            <div key={k}>
              <p className="text-[10px] font-semibold tracking-[0.3em] uppercase text-[#6F6F63]">{k}</p>
              <p className="mt-2 text-sm text-[#16180F]">{v}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
